// @flow
import _ from 'lodash';
import { createSelector } from 'reselect';
import type { StoreState } from '../types';

export const thisStateSelector = (state: StoreState): State => {
  return state.nutritionalValues;
};

export const currentNutritionValuesSelector = (state: any, productId: number) => {
  const nutritionalValues = thisStateSelector(state.nutritionalValues);
  return nutritionalValues
};
